import { CloseConfig, DeepPartial } from '@empathybroker/ebx-gluon';

export const MOBILE_CLOSE: DeepPartial<CloseConfig> = { components: { icon: 'CdlArrowIcon' } };
